export default "__VITE_ASSET__d9b64eda__"